import {
  GET_FARMS_KPIS_SERVICE_URL,
  GET_FARMS_SERVICE_URL,
} from '../api/lelyBackend/config';
import api from './api';
import { System } from './availableSystemApi';

export type Farm = {
  centerName: string;
  customerName: string;
  id: string;
  customerNumber: string;
  farmName: string;
  clusterName: string;
  country: string;
  city: string;
  street: string;
  version: string;
  accuracy: string;
  freetime: string;
  durationalarmstate: string;
  nrofloads: string;
  loadedweight: string;
  nrofalarms: string;
  isFavourite?: boolean; // FE
};

export type VectorKpi = {
  kpiName: string;
  value: string;
  unit: string;
};

export type FarmKpiResponse = {
  id: string;
  dailyVectorKpi: VectorKpi[];
  version: string;
};

export const farmsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFarms: build.query<Farm[], System[] | undefined>({
      query: (preferredSystems = []) => {
        const params = new URLSearchParams();

        preferredSystems.forEach((system) => {
          params.append('preferredSystems', system.id);
        });

        return {
          url: GET_FARMS_SERVICE_URL,
          params: params.toString() ? params : undefined,
        };
      },
      providesTags: ['Farms'],
    }),

    getFarmsKpis: build.query<FarmKpiResponse[], void>({
      query: () => ({
        url: GET_FARMS_KPIS_SERVICE_URL,
      }),
      providesTags: ['FarmKpis'],
    }),
  }),
});

export const {
  useGetFarmsQuery,
  useGetFarmsKpisQuery,
  useLazyGetFarmsKpisQuery,
} = farmsApi;

export default farmsApi;
